import "./EbooksGuides.module.css";
import Header from "@/reusable_sections/Header";
import Intro from "./sections/Intro";
import Guides from "./sections/Guides";
import Spotlight from "./sections/Spotlight";
import Footer from "@/reusable_sections/Footer";
export default function EbooksGuidesPage() {
  return <div>
      <Header />
      <Intro />
      <Guides />
      <Spotlight />
      <Footer />
    </div>;
}